const CREATIVE_VIDEO_DETAILS_END_POINTS = {
  VIDEO_DETAILS: (brandId: string, videoId: string): string =>
    `/brands/${brandId}/videos/${videoId}`
};

export default CREATIVE_VIDEO_DETAILS_END_POINTS;
